import { StringUtil } from "@mcleod/core";

export interface TrackingSearchRequestContext {
    movementId?: string;
    orderId?: string;
    isManifest?: boolean;
    searchFilter?: any;
}

interface TrackingContextReceiver {
    trackingSearchRequestContext?: TrackingSearchRequestContext;
}

export function createTrackingSearchRequestContext(
    movementId?: string,
    orderId?: string,
    isManifest: boolean = false
): TrackingSearchRequestContext {
    const searchFilter: any = {};

    if (!StringUtil.isEmptyString(movementId)) {
        searchFilter.id = movementId;
    }

    if (!StringUtil.isEmptyString(orderId)) {
        if (isManifest) {
            searchFilter["movement_order.order_id"] = orderId;
        } else {
            searchFilter["orders.id"] = orderId;
        }
    }

    return {
        movementId,
        orderId,
        isManifest,
        searchFilter
    };
}

export function applyTrackingSearchRequestContext(
    layout: TrackingContextReceiver,
    movementId?: string,
    orderId?: string,
    isManifest: boolean = false
): any {
    const context = createTrackingSearchRequestContext(movementId, orderId, isManifest);
    layout.trackingSearchRequestContext = context;
    return context.searchFilter;
}
